import request from '@/utils/request'
import host from '@/api/base/host'

const v1 = host.path('dev', { dev: 'v1' })
const v2 = host.path('dev', { dev: 'v2' })
// 获取实物商品组合详情
export const getCombinationDetail = data => {
  return request({
    url: v1('goods/getCombinationDetail'),
    method: 'post',
    data
  })
}

// 多商品预创建订单
export const createPreMultiOrder = data => {
  return request({
    url: v1('order/preMultiCreate'),
    method: 'post',
    data
  })
}

// 多商品创建订单
export const createMultiOrder = data => {
  return request({
    url: v2('order/h5/createMultiOrder'),
    method: 'post',
    data
  })
}
